import { AvatarGroup, Box, useTheme } from "@mui/material"
import { UserAvatar } from "minimals-template/components/user-avatar"
import { UserAccessOverflow } from "./user-access-overflow"

export function UserAccessGroup({
    max = 5,
    applyLimit = null,
    users = [],
    height = 24,
    width = 24,
    fontSize = "12px",
    sx = {},
}) {
    const theme = useTheme()

    if (users.length < 1) return null

    const limited = applyLimit != null && users.length > applyLimit
    const shown = limited ? users.slice(0, applyLimit) : users
    const surplus = users.length - shown.length

    const group = (
        <AvatarGroup
            sx={limited ? undefined : sx}
            data-cy="user-access-group"
            max={limited ? shown.length + 1 : max}
            slotProps={{
                additionalAvatar: {
                    sx: {
                        width,
                        height,
                        fontSize: `${fontSize} !important`,
                        backgroundColor: `${theme.palette.primary.light} !important`,
                    },
                },
            }}
        >
            {shown.map((user) => (
                <UserAvatar
                    key={user.id}
                    user={user}
                    sx={{
                        width,
                        height,
                        "& .MuiTypography-root": {
                            fontSize,
                        },
                    }}
                />
            ))}
        </AvatarGroup>
    )

    if (!limited) return group

    return (
        <Box sx={{ display: "inline-flex", alignItems: "center", ...sx }}>
            {group}
            <UserAccessOverflow surplus={surplus} users={users} width={width} height={height} fontSize={fontSize} />
        </Box>
    )
}
